import { Box, HStack, Text, addWithConfig } from '@rbilabs/universal-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import LoyaltyRewardsLogo from 'pages/loyalty/loyalty-rewards-logo';
import { getDesignToken, primitive, spacing } from 'styles/constants';
const MAX_WIDTH_FOR_REWARDS_LOGO = '262px';

export const PointsExpirationContainer = Box.withConfig({
  borderRadius: '10px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: primitive.$mayoEggWhite,
  backgroundColor: getDesignToken('background-card'),
  fontSize: 'md',
  color: primitive.$bbqBrown,
  marginBottom: '$2',
});

export const PointsExpirationHeader = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
});

export const PointsExpirationContent = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
  fontSize: 'sm',
  textAlign: 'center',
});

export const Divider = Box.withConfig({
  borderTopColor: primitive.$greyFive,
  borderTopWidth: '1px',
});

export const AvailableBalance = HStack.withConfig({
  marginTop: '$2',
});

export const NormalText = Text.withConfig({
  fontSize: 'md',
});

export const StyledLoyaltyPointsIcon = addWithConfig(LoyaltyPointsIcon).withConfig({
  width: '$6',
  height: '$6',
  marginTop: {
    base: '-2px',
    md: '1px',
  },
  marginLeft: '$1',
  _android: {
    marginTop: '-1px',
  },
});

export const ExpirationMessage = HStack.withConfig({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: spacing.$1_5,
  fontFamily: 'Flame-Regular',
  fontSize: 'md',
});

export const ExpirationDateTime = Text.withConfig({
  fontFamily: 'alternative',
  paddingLeft: spacing.$1_5,
  marginBottom: '$4',
});

export const PurchaseMessage = Text.withConfig({
  width: 'full',
  marginBottom: '$4',
  textAlign: 'center',
});

export const StyledRewardsLogo = LoyaltyRewardsLogo.withConfig({
  maxWidth: MAX_WIDTH_FOR_REWARDS_LOGO,
  width: 'full',
  marginTop: '$2',
});

export const AvailablePoints = Text.withConfig({
  fontFamily: 'alternative',
  marginX: '$1',
  lineHeight: {
    base: '21px',
    md: '24px',
  },
});
